import { Component } from '@angular/core';

@Component({
    selector: 'app-progress-spinner',
    template: `
        <div class="spinner-wrapper">
            <svg class="spinner" viewBox="0 0 50 50" width="80" height="80">
                <circle
                    class="spinner-circle"
                    cx="25"
                    cy="25"
                    r="20"
                    fill="none"
                    stroke-width="4"
                />
            </svg>
        </div>
    `,
    styles: [`
        :host {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 20px;
            line-height: 0;
            vertical-align: middle;
        }
        .spinner-wrapper {
            display: flex;
            align-items: center;
            justify-content: center;
            will-change: transform;
            backface-visibility: hidden;
            perspective: 1000px;
        }
        .spinner {
            width: 80px;
            height: 80px;
            animation: spinner-rotate 2s linear infinite;
            will-change: transform;
            backface-visibility: hidden;
            transform-origin: center center;
        }
        .spinner-circle {
            stroke: #0081a2;
            stroke-dasharray: 40, 100;
            stroke-dashoffset: 0;
            animation: spinner-dash 1.5s ease-in-out infinite;
            stroke-linecap: round;
        }
        @keyframes spinner-rotate {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
        @keyframes spinner-dash {
            0% {
                stroke-dasharray: 1, 100;
                stroke-dashoffset: 0;
            }
            50% {
                stroke-dasharray: 50, 100;
                stroke-dashoffset: -20;
            }
            100% {
                stroke-dasharray: 50, 100;
                stroke-dashoffset: -90;
            }
        }
    `],
})
export class ProgressSpinnerComponent {}
